import '../../../styles/style.css';

import * as React from 'react';

import { Card, CardText } from 'material-ui/Card';
import {
  GlanceDraft,
  GlanceMeta,
  GlanceTime,
  GlanceType,
  GlanceContextType,
  Image,
  ImageType,
  Role,
  StudioAppConfig,
  Region,
} from 'glance-datatypes';
import { Tooltip, TooltipStyles } from 'react-lightweight-tooltip';

import { CSSProperties } from 'react';
import Chip from 'material-ui/Chip';
import DropDownMenu from 'material-ui/DropDownMenu';
import FontIcon from 'material-ui/FontIcon';
import GlanceDraftDetails from './GlanceDraftDetails';
import GlanceThumbnail from './GlanceThumbnail';
import IconButton from 'material-ui/IconButton';
import ImageDropzone from '../../../components/ImageDropzone';
import MenuItem from 'material-ui/MenuItem';
import { Emoji, EmojiMapping, RegionPartnerTuple, CityStates } from '../types';
import Utils from '../../../Utils';
import { connect } from 'react-redux';
import { getPublishButtonAtributes } from '../draftsHelper';
import { blue300, red500, white } from 'material-ui/styles/colors';
import { blue500 } from 'material-ui/styles/colors';
import RestService from '../../../RestService';

const wallpaperWidth: string = '65px';
const detailsWidth: string = 'calc(100% - 65px)';
const wallpaperWidthExpanded = '10%';

const styles = {
  tooltipStyle: {
    wrapper: {
      zIndex: 1,
      cursor: 'arrow',
    },
    tooltip: {
      backgroundColor: '#808080',
      borderRadius: '10px',
      minWidth: '180px',
      textAlign: 'center',
      padding: '2px',
    },
    content: {
      backgroundColor: '#808080',
      color: '#FFFFFF',
      display: 'inline-block',
      fontSize: '0.9em',
      paddind: '0',
    },
    arrow: {
      borderTop: 'solid #808080 5px',
    },
    gap: {},
  } as TooltipStyles,
  readableChip: {
    margin: 1,
    backgroundColor: '#808080',
    display: 'inline-block',
    borderRadius: '1em',
    fontSize: '0.9em',
  } as React.CSSProperties,
  readableChipLive: {
    margin: 1,
    backgroundColor: blue500,
    color: '#ccc',
    display: 'inline-block',
    borderRadius: '1em',
    fontSize: '0.9em',
  } as React.CSSProperties,
  chip: {
    margin: 3,
  } as React.CSSProperties,
  wrapperDiv: {
    margin: '0px auto',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
  } as CSSProperties,
  cardTextDiv: {
    padding: '5px',
    display: 'flex',
    margin: '0px auto',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    height: '100%',
  },
  cardTextDivExpanded: {
    padding: '5px',
    display: 'flex',
    margin: '0px auto',
  },
  actionsDiv: {
    padding: '5px',
    display: 'flex',
    margin: '0px auto',
    position: 'absolute',
    right: 0,
    height: '100%',
    marginLeft: detailsWidth,
  },
  action: {
    margin: '0 auto',
  },
  wallpaperDiv: {
    padding: '5px',
    display: 'flex',
    minHeight: '100px',
    maxWidth: '120px',
  },
  wallpaper: {
    maxWidth: '270px',
    display: 'block',
    margin: '0px auto',
  },
  rightBottomCornerDiv: {
    color: '#ccc',
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '2%',
  } as CSSProperties,
  rightDiv: {
    position: 'absolute',
    bottom: '-1%',
    right: 0,
    color: '#ccc',
    padding: '1%',
    marginBottom: '2.5%',
  },
  marginTop: {
    marginTop: '35px',
  },
  marginAuto: {
    margin: '0 auto',
    height: '100%',
  },
};

interface GlanceDraftCardProps {
  studioAppConfig: StudioAppConfig;
  glanceDraftData: GlanceDraft;
  cardStyle?: React.CSSProperties;
  actions?: any;
  dropImage?: any;
  overlayImage?: any;
  bingeImage?: any;
  removed?: boolean;
  overlayRemoved?: boolean;
  bingeRemoved?: boolean;
  pristine?: boolean;
  errorMsg: string;
  regionPartnerList: RegionPartnerTuple[];
  role: Role;
  draftMeta: GlanceMeta[];
  bubbleData: any;
  cardType: number;
  adCoefficientDisabled: boolean;
  bucketPriorityDisabled: boolean;
  ecpmDisabled: boolean;
  rankDisabled: boolean;
  fCapDisabled: boolean;
  displayRank: boolean;
  storyCount: number;
  disableCopy: boolean;

  onEdit: (key: string, value: any) => any;
  onSave: (isCTASecReq?: boolean) => any;
  onOverride: () => any;
  onPublish: () => any;
  onRemove: () => any;
  onPause: () => any;
  onImageDrop: (file: any) => any;
  onOverlayImageDrop: (file: any) => any;
  onBingeImageDrop: (file: any) => any;
  removeImage: () => any;
  removeOverlayImage: () => any;
  removeBingeImage: () => any;
  singleClickPublish: (draft: GlanceDraft) => any;
  copyDraft: (draft: GlanceDraft) => any;
  cityStates: CityStates[];
  peekSourceList: string[];
  dspPeekSourceList: string[];
}

interface State {
  expanded: boolean;
  language: string;
  publishButtonDisability: boolean;
  publishButtonTooltipText: string;
}

class GlanceDraftCard extends React.Component<GlanceDraftCardProps, State> {
  constructor(props: GlanceDraftCardProps) {
    super(props);
    this.state = {
      expanded: false,
      language: 'ENG',
      publishButtonDisability: false,
      publishButtonTooltipText: '',
    };

    this.removeImage = this.removeImage.bind(this);
    this.onImageDrop = this.onImageDrop.bind(this);
    this.onOverlayImageDrop = this.onOverlayImageDrop.bind(this);
    this.onBingeImageDrop = this.onBingeImageDrop.bind(this);
    this.removeOverlayImage = this.removeOverlayImage.bind(this);
    this.removeBingeImage = this.removeBingeImage.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onPublish = this.onPublish.bind(this);
    this.onOverride = this.onOverride.bind(this);
    this.onPublish = this.onPublish.bind(this);
    this.toggleExpansion = this.toggleExpansion.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.checkLanguageCategory = this.checkLanguageCategory.bind(this);
    this.readStartTime = this.readStartTime.bind(this);
  }

  componentDidMount() {
    const initialStateFromProp = this.getInitialStateFromProp(this.props);
    this.setState((state, props) => ({
      ...this.state,
      ...initialStateFromProp,
    }));
  }

  componentWillReceiveProps(nextProps: GlanceDraftCardProps) {
    const initialStateFromProp = this.getInitialStateFromProp(nextProps);
    this.setState((state, props) => ({
      ...this.state,
      ...initialStateFromProp,
    }));
  }

  getInitialStateFromProp = (props: GlanceDraftCardProps) => {
    const { studioAppConfig, glanceDraftData, pristine, removed } = props;
    const editable = !removed;
    const {
      disable: publishButtonDisability,
      tooltip: publishButtonTooltipText = '',
    } = getPublishButtonAtributes({
      editable,
      glanceDraftData,
      studioAppConfig,
      pristine,
    });
    return {
      publishButtonDisability: publishButtonDisability,
      publishButtonTooltipText: publishButtonTooltipText,
    };
  };

  toggleExpansion() {
    this.setState({
      ...this.state,
      expanded: !this.state.expanded,
    });
  }

  onEdit(key: string, value: any) {
    this.props.onEdit(key, value);
  }

  onSave(isCTASecReq?: boolean) {
    this.props.onSave(isCTASecReq);
  }

  onOverride() {
    this.props.onOverride();
  }

  onRemove() {
    this.props.onRemove();
  }

  onPause() {
    this.props.onPause();
  }

  onPublish() {
    this.props.onPublish();
  }

  onImageDrop(files: any[]) {
    this.props.onImageDrop(files[0]);
  }

  onOverlayImageDrop(files: any[]) {
    this.props.onOverlayImageDrop(files[0]);
  }

  onBingeImageDrop(files: any[]) {
    this.props.onBingeImageDrop(files[0]);
  }

  removeImage() {
    this.props.removeImage();
  }

  removeOverlayImage() {
    this.props.removeOverlayImage();
  }

  removeBingeImage() {
    this.props.removeBingeImage();
  }

  getUrl(image: Image, imageType: ImageType, dropImage: any): string {
    const {
      studioAppConfig: { cdnPrefix },
    } = this.props;
    if (image) {
      let meta: any;
      image.imageMetas.forEach((elem) => {
        if (elem.type == imageType) {
          meta = elem;
        }
      });

      if (meta === null || typeof meta == 'undefined') {
        return null;
      }

      return Utils.getImagePath(cdnPrefix, image.id, meta);
    }
    if (dropImage) {
      return dropImage.image.preview;
    }

    return null;
  }

  checkLanguageCategory(value) {
    const { glanceDraftData } = this.props;

    if (glanceDraftData.type === GlanceType.WALLPAPER) {
      return false;
    }

    if (glanceDraftData.categoryIds == null || value == null) {
      return true;
    }

    if (
      glanceDraftData.categoryIds.find(
        (category) => category === '#tamil_news',
      ) != undefined &&
      !(value == 'ta')
    ) {
      return false;
    }

    if (
      glanceDraftData.categoryIds.find(
        (category) => category === '#telugu_news',
      ) != undefined &&
      !(value == 'te')
    ) {
      return false;
    }

    if (
      glanceDraftData.categoryIds.find(
        (category) => category === '#bengali_news',
      ) != undefined &&
      !(value == 'bn')
    ) {
      return false;
    }

    if (
      glanceDraftData.categoryIds.find(
        (category) => category === '#marathi_news',
      ) != undefined &&
      !(value == 'mr')
    ) {
      return false;
    }

    if (
      glanceDraftData.categoryIds.find(
        (category) => category === '#kannada_news',
      ) != undefined &&
      !(value == 'kn')
    ) {
      return false;
    }

    return true;
  }

  handleLanguageChange(field, context, value) {
    if (!this.checkLanguageCategory(value)) {
      return;
    }
    this.state.language = value;
    console.log(value);
    this.setState({
      ...this.state,
      language: value,
    });
    this.onEdit('language', value);
  }

  readStartTime(glanceTime: GlanceTime) {
    if (glanceTime && glanceTime != null) {
      if (glanceTime.startTime.absoluteTime) {
        const absoluteTime: number =
          glanceTime.startTime.absoluteTime.timeInSecs;
        return Utils.getReadableAbsoluteTime(absoluteTime);
      } else if (glanceTime.startTime.relativeTime) {
        return Utils.getReadableRelativeTime(glanceTime.startTime.relativeTime);
      } else return '';
    } else return '';
  }

  checkExpiry(glanceTime: GlanceTime) {
    const currentdateEpochInSecs: number = Math.floor(
      new Date().getTime() / 1000,
    );
    const endDateEpochInSecs =
      Utils.getEpochFinalInSecs(glanceTime) +
      Utils.getMillis(glanceTime.duration) / 1000;
    return currentdateEpochInSecs > endDateEpochInSecs;
  }

  render() {
    const detailStyle = this.state.expanded
      ? styles.cardTextDivExpanded
      : styles.cardTextDiv;
    const paddingBottom = this.state.expanded ? '0em' : '';
    const wallpaperDivWidth = this.state.expanded
      ? wallpaperWidthExpanded
      : wallpaperWidth;
    const {
      glanceDraftData,
      dropImage,
      draftMeta,
      regionPartnerList,
      bubbleData,
    } = this.props;
    const {
      image,
      overlayImage,
      bingeImage,
      type: glanceType,
      peek,
      publisherData,
      userLifeTimeFilter,
      adCoefficient,
      bucketPriority,
      rankInBubble,
      campaignMeta,
      dspCampaignData
    } = glanceDraftData;
    const { isDspCampaign } = dspCampaignData || { isDspCampaign: false };
    const eCpm = campaignMeta ? campaignMeta.eCpm : null;
    const { tvVideoPeek = null } = peek || {};
    const { publishButtonDisability, publishButtonTooltipText } = this.state;

    let backgroundStyle: React.CSSProperties = {};
    if (this.props.removed) {
      backgroundStyle = {
        backgroundColor: '#E8E8E8',
      };
    }

    let errorText;
    if (
      (dropImage && dropImage.image && !dropImage.attrSource) ||
      (image && !image.attribution)
    ) {
      errorText = "Wallpaper can't be saved/published without Glance source";
    } else if (!image && !dropImage) {
      errorText = "Draft doesn't have image yet";
    } else if (glanceType == GlanceType.STORY && peek && !peek.sourceName) {
      errorText = "Draft doesn't have peek source name or title";
    } else if (glanceType == GlanceType.SPONSORED && !publisherData) {
      errorText = 'Publisher must be specified for Sponsored Content';
    } else if (
      userLifeTimeFilter &&
      userLifeTimeFilter.startDay !== null &&
      userLifeTimeFilter.startDay !== 8 &&
      !userLifeTimeFilter.endDay
    ) {
      errorText = 'End Day is missing';
    } else if (glanceType == GlanceType.SPONSORED) {
      if (adCoefficient == null && !isDspCampaign) {
        errorText = 'Ads Coefficient must be specified for Type: Sponsored';
      }
      if (bucketPriority == null) {
        errorText = 'Bucket Priority must be specified for Type: Sponsored';
      }
      if (eCpm == null && !isDspCampaign) {
        errorText = 'ECPM must be specified for Type: Sponsored';
      }
      if (this.props.storyCount > 0 && rankInBubble === null) {
        errorText = 'Missing Rank';
      }
    }

    const showBubbleImage = () => {
      const commonChecks = this.state.expanded && !tvVideoPeek &&
                           glanceDraftData.bubbleId &&
                           bubbleData && bubbleData.imagePath

      if (commonChecks && glanceType === GlanceType.SPONSORED) {
        return true;
      } else if (commonChecks && glanceType != GlanceType.WALLPAPER &&
        glanceDraftData.peek.glanceContext === GlanceContextType.LIVE) {
        return true;
      }
      return false;
    }

    return (
      <div>
        <Card
          style={{ ...this.props.cardStyle, ...backgroundStyle }}
          containerStyle={this.props.cardStyle}
        >
          <CardText
            style={{
              padding: '0px',
              position: 'relative',
              paddingBottom: paddingBottom,
            }}
          >
            <div className="display-flex" style={{...styles.wrapperDiv, alignItems: isDspCampaign ? 'end' : 'center' }}>
              <div
                className=""
                style={{
                  width: wallpaperDivWidth,
                  ...styles.wallpaperDiv,
                  display: this.state.expanded ? 'block' : 'flex',
                  maxHeight: this.state.expanded ? null : '110px',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={
                      this.state.expanded ? styles.marginTop : styles.marginAuto
                    }
                  >
                    {image ||
                    (this.props.dropImage && this.props.dropImage.image) ? (
                      <GlanceThumbnail
                        width="100%"
                        imageUrl={this.getUrl(
                          image,
                          ImageType.LEGACY,
                          this.props.dropImage,
                        )}
                        overlayImageUrl={this.getUrl(
                          overlayImage,
                          ImageType.LEGACY,
                          this.props.dropImage,
                        )}
                        bingeImageUrl={this.getUrl(
                          bingeImage,
                          ImageType.LEGACY,
                          this.props.dropImage,
                        )}
                        shouldShowCarousal={!this.state.expanded}
                        style={{ margin: 'auto', display: 'inline-block' }}
                        imageStyle={{ margin: 'auto', display: 'block' }}
                      />
                    ) : (
                      <ImageDropzone
                        onDrop={this.onImageDrop}
                        flex={true}
                        disableClick={
                          !this.state.expanded || this.props.removed
                        }
                      />
                    )}
                    {this.state.expanded ? (
                      <div className="imageLabel">Drop Image</div>
                    ) : null}
                    {(image ||
                      (this.props.dropImage && this.props.dropImage.image)) &&
                    this.state.expanded &&
                    !this.props.removed ? (
                      <IconButton
                        onClick={this.removeImage}
                        tooltip={'Remove Image'}
                        style={{ display: 'block', margin: '0 auto' }}
                      >
                        <FontIcon
                          className="material-icons"
                          color={red500}
                          style={{ fontSize: '2em' }}
                        >
                          close
                        </FontIcon>
                      </IconButton>
                    ) : null}
                  </div>

                  <div
                    style={
                      this.state.expanded ? styles.marginTop : styles.marginAuto
                    }
                  >
                    {this.state.expanded &&
                    !tvVideoPeek &&
                    glanceType != GlanceType.WALLPAPER ? (
                      overlayImage ||
                      (this.props.overlayImage &&
                        this.props.overlayImage.image) ? (
                        <GlanceThumbnail
                          width="90%"
                          imageUrl={this.getUrl(
                            overlayImage,
                            ImageType.LEGACY,
                            this.props.overlayImage,
                          )}
                          style={{
                            margin: 'auto',
                            display: 'inline-block',
                            backgroundColor: 'black',
                          }}
                          imageStyle={{ margin: 'auto', display: 'block' }}
                        />
                      ) : (
                        <ImageDropzone
                          onDrop={this.onOverlayImageDrop}
                          flex={true}
                          disableClick={
                            !this.state.expanded || this.props.overlayRemoved
                          }
                        />
                      )
                    ) : (
                      ''
                    )}
                    {this.state.expanded && !tvVideoPeek ? (
                      <div className="imageLabel">Overlay Image</div>
                    ) : null}
                    {(overlayImage ||
                      (this.props.overlayImage &&
                        this.props.overlayImage.image)) &&
                    this.state.expanded &&
                    !tvVideoPeek &&
                    !this.props.overlayRemoved ? (
                      <IconButton
                        onClick={this.removeOverlayImage}
                        tooltip={'Remove Overlay Image'}
                        style={{ display: 'block', margin: '0 auto' }}
                      >
                        <FontIcon
                          className="material-icons"
                          color={red500}
                          style={{ fontSize: '2em' }}
                        >
                          close
                        </FontIcon>
                      </IconButton>
                    ) : null}
                  </div>

                  <div
                    style={
                      this.state.expanded ? styles.marginTop : styles.marginAuto
                    }
                  >
                    {this.state.expanded &&
                    !tvVideoPeek &&
                    glanceType != GlanceType.WALLPAPER ? (
                      bingeImage ||
                      (this.props.bingeImage && this.props.bingeImage.image) ? (
                        <GlanceThumbnail
                          width="90%"
                          imageUrl={this.getUrl(
                            bingeImage,
                            ImageType.LEGACY,
                            this.props.bingeImage,
                          )}
                          style={{ margin: 'auto', display: 'inline-block' }}
                          imageStyle={{ margin: 'auto', display: 'block' }}
                        />
                      ) : (
                        <ImageDropzone
                          onDrop={this.onBingeImageDrop}
                          flex={true}
                          disableClick={
                            !this.state.expanded || this.props.bingeRemoved
                          }
                        />
                      )
                    ) : (
                      ''
                    )}
                    {this.state.expanded && !tvVideoPeek ? (
                      <div className="imageLabel">Binge Image</div>
                    ) : null}
                    {(bingeImage ||
                      (this.props.bingeImage && this.props.bingeImage.image)) &&
                    this.state.expanded &&
                    !tvVideoPeek &&
                    !this.props.bingeRemoved ? (
                      <IconButton
                        onClick={this.removeBingeImage}
                        tooltip={'Remove Binge Image'}
                        style={{ display: 'block', margin: '0 auto' }}
                      >
                        <FontIcon
                          className="material-icons"
                          color={red500}
                          style={{ fontSize: '2em' }}
                        >
                          close
                        </FontIcon>
                      </IconButton>
                    ) : null}
                  </div>
                  {/* Bubble Image */}
                  <div
                    style={
                      this.state.expanded
                        ? { ...styles.marginTop, position: 'relative' }
                        : styles.marginAuto
                    }
                  >
                  {
                    showBubbleImage() ? (
                    <div>
                      <GlanceThumbnail
                        width="90%"
                        imageUrl={Utils.getBubbleImagePath(
                          bubbleData ? bubbleData.imagePath : '',
                        )}
                        style={{ margin: 'auto', display: 'inline-block' }}
                        imageStyle={{ margin: 'auto', display: 'block' }}
                      />
                      <Chip
                        style={{ position: 'absolute', top: 0, left: 125 }}
                        key={'useBubbleImageAsRibbonIcon'}
                        backgroundColor={
                          glanceDraftData.peek.useBubbleImageAsRibbonIcon
                            ? blue300
                            : null
                        }
                        onTouchTap={() => {
                          this.onEdit(
                            'useBubbleImageAsRibbonIcon',
                            !glanceDraftData.peek.useBubbleImageAsRibbonIcon,
                          );
                        }}
                      >
                        {glanceDraftData.peek.useBubbleImageAsRibbonIcon
                          ? 'Show icon on LS'
                          : 'Dont show icon on LS'}
                      </Chip>
                    </div>) : ''
                  }
                  </div>
                </div>
              </div>
              <div
                className="display-flex"
                style={{ width: detailsWidth, ...detailStyle }}
              >
                <GlanceDraftDetails
                  glanceDraftData={glanceDraftData}
                  onEdit={this.onEdit}
                  editable={!this.props.removed}
                  detailed={this.state.expanded}
                  onSave={this.onSave}
                  pristine={this.props.pristine}
                  onRemove={this.onRemove}
                  onPause={this.onPause}
                  onPublish={this.onPublish}
                  onOverride={this.onOverride}
                  disableAttribution={
                    (!dropImage || !dropImage.image) && !glanceDraftData.image
                  }
                  role={this.props.role}
                  bubbleData={this.props.bubbleData}
                  cardType={this.props.cardType}
                  adCoefficientDisabled={this.props.adCoefficientDisabled}
                  bucketPriorityDisabled={this.props.bucketPriorityDisabled}
                  ecpmDisabled={this.props.ecpmDisabled}
                  rankDisabled={this.props.rankDisabled}
                  fCapDisabled={this.props.fCapDisabled}
                  displayRank={this.props.displayRank}
                  storyCount={this.props.storyCount}
                  cityStates={this.props.cityStates}
                  peekSourceList= {this.props.peekSourceList}
                  dspPeekSourceList={this.props.dspPeekSourceList}
                />
              </div>
            </div>
            <div style={styles.rightDiv}>
              <div
                style={{
                  display: 'inline-block',
                  flexWrap: 'wrap',
                  marginBottom: '20px',
                  marginTop: '30px',
                  maxWidth: '1000px',
                }}
              >
                {// 0: {region: 2, partner: undefined}
                regionPartnerList && regionPartnerList.length > 0
                  ? regionPartnerList.map((tuple, index) => {
                      if (tuple.partner && tuple.region) {
                        return (
                          <Tooltip
                            content={
                              draftMeta && draftMeta[index]
                                ? this.readStartTime(
                                    draftMeta[index].glanceTime,
                                  )
                                : null
                            }
                            styles={styles.tooltipStyle}
                            key={'published_to_' + tuple.partner.partnerId}
                          >
                            <Chip
                              style={
                                this.checkExpiry(draftMeta[index].glanceTime) ||
                                draftMeta[index].removed
                                  ? { ...styles.readableChip }
                                  : { ...styles.readableChipLive }
                              }
                              labelColor={white}
                              labelStyle={{ lineHeight: '1.5em' }}
                              key={
                                'published_to_' +
                                tuple.partner.partnerId +
                                tuple.region
                              }
                            >
                              {tuple.partner.name +
                                ': ' +
                                Utils.getReadableRegionName(tuple.region)}
                            </Chip>
                          </Tooltip>
                        );
                      }
                    })
                  : ''}
              </div>
            </div>
            <div
              style={
                this.state.expanded
                  ? { ...styles.rightBottomCornerDiv }
                  : { ...styles.rightBottomCornerDiv, marginTop: '-50px' }
              }
            >
              {this.props.errorMsg}
              {this.state.expanded && errorText ? (
                <span style={{ color: red500 }}>{errorText}</span>
              ) : null}
              <DropDownMenu
                value={glanceDraftData.glanceLanguageId}
                onChange={this.handleLanguageChange}
              >
                <MenuItem
                  value={null}
                  primaryText={'Language'}
                  key={'empty'}
                ></MenuItem>
                {this.props.studioAppConfig.glanceLanguages.map(
                  (item, index) => {
                    return (
                      <MenuItem
                        value={item.id}
                        primaryText={item.id}
                        key={item.id}
                      />
                    );
                  },
                )}
              </DropDownMenu>
              <IconButton
                key="copy"
                disabled={this.props.disableCopy}
                onClick={() => this.props.copyDraft(glanceDraftData)}
              >
                <FontIcon
                  className="material-icons"
                  color={'#ccc'}
                  style={{ fontSize: '2em' }}
                >
                  add_circle
                </FontIcon>
              </IconButton>
              <IconButton
                key="bulkpublishButton"
                onClick={() => {
                  this.props.singleClickPublish(glanceDraftData);
                }}
                disabled={publishButtonDisability}
                tooltip={publishButtonTooltipText}
              >
                <FontIcon
                  className="material-icons"
                  style={{ fontSize: '2em' }}
                >
                  publish
                </FontIcon>
              </IconButton>
              <IconButton
                onClick={this.toggleExpansion}
                tooltip={this.state.expanded ? 'Close' : 'Edit'}
                key="toggleExpansionButton"
              >
                <FontIcon
                  className="material-icons"
                  color={'#ccc'}
                  style={{ fontSize: '2em' }}
                >
                  {this.state.expanded ? 'keyboard_arrow_up' : 'edit'}
                </FontIcon>
              </IconButton>
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    studioAppConfig: state.studioAppConfig,
  };
};

export default connect(mapStateToProps)(GlanceDraftCard);



// WEBPACK FOOTER //
// ./src/pages/drafts/components/GlanceDraftCard.tsx